// src/prototype/enterprise/EnterpriseJourneyBar.tsx
// ============================================================
// The locked journey bar, for use on /enterprise stub routes (which have no EA page to
// render it). On EA routes the EA page renders its own journey bar, so AppShell renders
// this ONLY on /enterprise routes to avoid doubling it.
//
// The journey bar (Personalize → Evaluate → Execute) is rendered, NOT modified. Its steps
// navigate to the storefront routes; enterprise mode is sticky STATE (useEnterpriseMode),
// decoupled from the route, so that navigation keeps the navy bar present.
//
// On an Enterprise tab there is no active journey step, so the bar is rendered NEUTRAL via
// the shell-level activeStepOverride={null} prop — no step highlighted/pulsing. The steps
// stay clickable (clicking one navigates to that storefront route, where the EA page's own
// bar highlights it normally).
// ============================================================

import React from 'react';
import { useLocation } from 'react-router-dom';
import { EAJourneyBarFrame } from '../components/EAJourneyBarFrame';
import { ENTERPRISE_TAB_COPY } from './enterpriseTabs';


export const EnterpriseJourneyBar: React.FC = () => {
  // The bar stays neutral (no active step); the active /enterprise/* tab supplies the
  // context-row copy (two-part, styled like a storefront step description).
  const { pathname } = useLocation();
  const key = Object.keys(ENTERPRISE_TAB_COPY).find((k) => pathname.startsWith(k));
  const description = key ? ENTERPRISE_TAB_COPY[key] : undefined;
  return (
    // Same wrapper the EA pages use, so the locked journey bar looks identical.
    <EAJourneyBarFrame activeStepOverride={null} neutralDescription={description} />
  );
};

export default EnterpriseJourneyBar;
